import { Box, Typography } from '@mui/material';
import React from 'react';

export const PaywallCardPricePerMonth = ({
  price,
  subtext,
}: {
  price: number;
  subtext: string;
}) => {
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          marginBottom: 1,
        }}
      >
        <Typography variant="h1">€ {price}</Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Typography variant="body2">per month</Typography>
          <Typography variant="caption">billed annually</Typography>
        </Box>
      </Box>
      <Typography variant="body2">{subtext}</Typography>
    </Box>
  );
};
